import "./style.css";

export default class Header {
  static selector = ".header";

  constructor(block) {
    this.block = block;

    this.bookValuationBtn = this.block.querySelector('[href="#book-valuation"');

    if(this.bookValuationBtn) {
      this.bookValuationBtn.addEventListener('click', () => {
          window.App.modals.bookValuationModal.open();
      })      
    }
  }

  // Public methods
  onResize() {}
  onScroll() {}
}
